export class CurrencySettings {
  name: string
  scale: number
  roundingMode: string
}
